function isSuccess(xhr) {
  return xhr.status == 204 || xhr.status == 202 || xhr.status == 200
}

class DeletePicture extends HTMLElement {

  connectedCallback() {
    this.addEventListener('click', () => {
      if (confirm(`Do you really want to delete this picture?`)) {
        const xhr = new XMLHttpRequest()
        const icon = this.querySelector('i')
        const origIconClass = icon.className

        const resetIcon = () => {
          icon.className = origIconClass
        }

        icon.className = 'pe-7s-config pe-spin'

        xhr.addEventListener('load', () => {
          resetIcon()

          if (isSuccess(xhr)) {
            document.location.href = this.getAttribute('next')
          }
        })

        xhr.addEventListener('error', resetIcon)
        xhr.addEventListener('abort', resetIcon)

        xhr.open('DELETE', this.getAttribute('href'))
        xhr.send()
      }
    })
  }
}

class FavPicture extends HTMLElement {

  connectedCallback() {
    this.addEventListener('click', () => {
      const xhr = new XMLHttpRequest()
      const method = this.classList.contains('active') ? 'DELETE' : 'PATCH';

      xhr.addEventListener('load', () => {
        if (isSuccess(xhr)) {
          this.classList.toggle('active')
        }
      })

      xhr.open(method, this.getAttribute('href'))
      xhr.send()
    })
  }
}

class VideoToggle extends HTMLElement {

  connectedCallback() {
    const image = <HTMLImageElement>document.querySelector(this.getAttribute('image'))
    const video = <HTMLVideoElement>document.querySelector(this.getAttribute('video'))

    this.addEventListener('click', () => {
      const active = this.classList.toggle('active')

      if (active) {
        image.classList.add('hide')
        video.classList.remove('hide')

        // Start video
        video.play()
      } else {
        image.classList.remove('hide')
        video.classList.add('hide')

        // Pause video
        video.pause()
      }
    })
  }

}


window.customElements.define('delete-picture', DeletePicture, { extends: 'a' })
window.customElements.define('fav-picture', FavPicture, { extends: 'a' })
window.customElements.define('video-toggle', VideoToggle, { extends: 'a' })



// WEBPACK FOOTER //
// ./assets/scripts/picture.ts